/*
 * @Copyright:
 * -----------------------------------------------------------------------------------
 *  Kingsoft Office Enterprise Cloud Services.
 *  Copyright (c) Kingsoft Office,All rights reserved.
 * -----------------------------------------------------------------------------------
 *
 * @Date: 2020-08-24 17:51:03
 * @Author: Kaven.D
 * @LastEditors: Kaven.D
 * @LastEditTime: 2020-09-24 11:36:33
 * @Description:
 */

import {
  VISABEL,
  DIALOGDATA,
  CLOSEDIALOG,
  SHOWDIALOG,
  SETDIALOGDATA,
} from './constants'
export default {
  [SHOWDIALOG]: state => {
    state[VISABEL] = true
  },
  [SETDIALOGDATA]: (
    state,
    { companyName = '', companyId = '', openUrl = '' }
  ) => {
    state[DIALOGDATA].companyName = companyName
    state[DIALOGDATA].companyId = companyId
    state[DIALOGDATA].openUrl = openUrl
  },
  [CLOSEDIALOG]: state => {
    state[VISABEL] = false
    state[DIALOGDATA].companyName = ''
    state[DIALOGDATA].companyId = ''
    state[DIALOGDATA].openUrl = ''
  },
}
